import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getCategoryListByProfile = async (userId: number, lang_code: string) => {
  return secureGet("/api/survey/getLoopSurveyProfileCategory", { userId, lang_code });
};

export const getQuestionsByProfile = (userId: number, category: number, lang_code: string) => {
  return secureGet("/api/survey/getLoopSurveyProfileQuestionAndOptionsByCategory", { userId, category, lang_code });
};

export const saveAnswers = async (insertData) => {
  return securePost("/api/survey/saveLoopSurveyUserAnswer", insertData);
};

export const getCurrentProfileAnswers = async (categoryId: string, userId: number) => {
  return secureGet("/api/survey/profileAnswers", { categoryId, userId });
};